import React, {useContext, useEffect, useRef, useState} from 'react';
import FilledButtonM from "@common/components/button/FilledButtonM";
import {theme} from "@common/theme/theme";
import FeelingQuizItem from "@common/chapters/feeling-quiz/FeelingQuizItem";
import {FlatList, ScrollView, View} from "react-native";
import {DimensionsContext, IS_WEB} from "@common/utils/mobileUtils";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {connect} from "react-redux";
import {useController, useForm} from "react-hook-form";
import {staticDataService} from "@data/services/staticDataService";
import {ActivityIndicator} from "react-native-paper";
import {capitalize} from "@data/utility/Utils";
import TextInputM from "@common/components/input/TextInputM";
import {authService} from "@data/services/authService";
import {useApiStatus} from "@common/hooks/useApiStatus";
import {useNavigation} from "@react-navigation/native";
import {putCongrats, putNextScreenParams} from "@data/redux/actions/navigation";
import StartingFormHeader from "./preparation-form/StartingFormHeader";
import TextM from "@common/components/text/TextM";
import {congratsTypes} from "@common/screens/CongratsScreen";
import {DialogM} from "@common/components/alert/dialog/Dialog";

const StudentEvaluationForm = (props) => {
    const [selectedIndexes, setSelectedIndexes] = useState({});
    const flatListRef = useRef(null);
    const dimensions = useContext(DimensionsContext);
    const navigation = useNavigation();
    const questions = props.staticData?.parent_evaluation_pillars;
    const isStep3 = props.user?.todo_activities?.length === 0

    const {control, handleSubmit, formState: {errors}, setValue} = useForm({});
    const {field} = useController({
        control,
        name: "parent_evaluation_scores",
    });

    useEffect(() => {
        if (!props.staticData?.parent_evaluation_pillars) {
            props.apiRequest(staticDataService.getStaticDataTrial);
        }
    }, []);

    const onSelectAnswer = (answer, type) => {
        const updatedIndexes = {
            ...selectedIndexes,
            [type]: answer
        };
        setSelectedIndexes(updatedIndexes);
        field.onChange(updatedIndexes);
    };

    const renderItem = ({item, index}) => {
        const type = Object.keys(questions)[index];
        const question = capitalize(questions[type]?.question);
        const pillars = questions[type]?.pillars || [];

        return (
            <FeelingQuizItem
                question={question}
                onSelectAnswer={onSelectAnswer}
                type={type}
                selectedIndexes={selectedIndexes}
                numberOfItems={pillars.length + 1}
                descriptions={pillars.map(opt => opt.description)}
                labels={pillars.map(opt => opt.label)}
            />
        );
    };

    const onSubmit = (data) => {
        if (props.postStudentEvaluationRequest) return;
        props.apiRequest(authService.postStudentEvaluation, {}, {...data});
    };

    useApiStatus(
        authService.postStudentEvaluation, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            if (!isStep3) {
                const congrats = []

                congrats.push({
                    congratsType: congratsTypes.GENERIC,
                    congratsData: {
                        title: `Le profil de ${props.user?.firstname} a bien été complété`,
                        text: "Vous pouvez dès maintenant découvrir l’application en attendant la séance d’essai."
                    }
                })
                props.putCongrats(congrats)
                navigation.replace("congrats")

            } else
                onIgnoreStep()
        } // success callback
    );

    const onIgnoreStep = () => {
        if (isStep3)
            navigation.replace("trial-preparation-form")
        else
            navigation.replace("menu")
    }

    const onCloseStep = () => {
        if (!props.user?.champion_intros_viewed_at?.zoe) {
            DialogM.show({
                text1: 'Quitter ce formulaire ?',
                text2: `Ces informations sont importantes pour préparer au mieux l’accompagnement de ${props.user.firstname}`,
                buttonText1: 'Oui, quitter',
                onPress: () => {
                    props.putNextScreenParams({
                        name: "zoe"
                    })

                    const nextScreen = {
                        nextScreen: "intro"
                    }

                    const congrats = []

                    if (IS_WEB) {
                        congrats.push({
                            congratsType: congratsTypes.DOWNLOAD_APP,
                            congratsData: {}
                        })
                    }

                    props.putCongrats(congrats)
                    navigation.replace("congrats", {
                        ...nextScreen
                    })
                },
                buttonText2: 'Annuler',
            })
        } else {
            navigation.goBack()
        }
    }

    return (
        <ScrollView style={{width: dimensions.width, alignSelf: 'center'}}>
            <StartingFormHeader step={2} totalSteps={3} stepTitle={" Auto-évaluation"} title={"Compléter son profil"}
                                onClose={onCloseStep}/>

            <View style={{
                marginBottom: 10,
                marginTop: 30,
                width: dimensions?.width,
                flex: 1,
                alignSelf: 'center'
            }}>
                {props.getStaticDataTrialRequest ? <ActivityIndicator/> :
                    questions && <FlatList
                        data={Object.values(questions)}
                        ref={flatListRef}
                        style={{
                            width: dimensions?.width
                        }}
                        contentContainerStyle={{
                            paddingTop: 20,
                            paddingBottom: 100,
                            alignItems: "center"
                        }}
                        keyExtractor={(_, index) => index.toString()}
                        ListFooterComponent={() =>
                            <View style={{width: dimensions?.width - 40}}>
                                <TextM
                                    color={theme.colors.primary}
                                    fontSize={14}
                                    fontWeight={"Bold"}
                                >
                                    {'Commentaire'}
                                </TextM>
                                <TextInputM
                                    placeholder="Ajouter toute précision utile concernant les besoins de votre enfant..."
                                    name="parent_evaluation_comment"
                                    style={{
                                        width: dimensions?.width - 40,
                                        height: 120,
                                        backgroundColor: theme.colors.white,
                                        alignSelf: 'center',
                                        marginBottom: 20
                                    }}
                                    multiline={true}
                                    onChangeAdditional={(value) => {
                                    }}
                                    control={control}
                                    errors={errors}
                                />
                            </View>
                        }
                        renderItem={renderItem}
                    />}
            </View>
            {!!questions && <View style={{
                marginTop: 10,
                marginBottom: 0,
                position: 'absolute',
                bottom: 0,
                alignSelf: "center",
            }}>
                <FilledButtonM
                    label={"Envoyer"}
                    color={theme.colors.primary}
                    style={{}}
                    disabled={props.postStudentEvaluationRequest || !Object.keys(questions).every(key => selectedIndexes[key])}
                    loading={props.postStudentEvaluationRequest}
                    onPress={handleSubmit(onSubmit)}
                />
                <FilledButtonM
                    onPress={onIgnoreStep}
                    mode={"text"}
                    label={"Compléter plus tard"}
                />
            </View>}
        </ScrollView>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        staticData: state.data.staticData?.trial_static_data,
        postStudentEvaluationRequest: state.api.postStudentEvaluation?.request,
        getStaticDataTrialRequest: state.api.getStaticDataTrial?.request,
    };
};

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    putNextScreenParams,
    putCongrats
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentEvaluationForm);
